import { createFileRoute } from '@tanstack/react-router';

import { getSoftwareCategories } from '../../-query/api';

export const Route = createFileRoute(
  '/_staff/software/_layout/library/category/$category/',
)({
  loader: async () => {
    const categories = await getSoftwareCategories();
    return { categories } as const;
  },
});
